import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, OnInit } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterLink } from '@angular/router';
import { CollectionButtonComponent } from '../collection-button/collection-button.component';
import { IconSimpleComponent } from '../icon-simple/icon-simple.component';
import { SeriesComponent } from '../series/series.component';

import { ISuiteEntity, IParentEntity, ISelectItem, ResourceService } from '@jit/data-layer';
import { SimpleSelectComponent } from '../simple-select/simple-select.component';

const suiteColorMap: Record<string, string> = {
  reading: 'pink',
  lectura: 'orange',
  math: 'blue',
  undefined: 'white',
};

@Component({
  selector: 'jit-suite',
  templateUrl: './suite.component.html',
  styleUrls: ['./suite.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    IconSimpleComponent,
    RouterLink,
    CollectionButtonComponent,
    SeriesComponent,
    SimpleSelectComponent,
  ],
})
class SuiteComponent implements OnInit {
  @Input()
  suite!: ISuiteEntity;

  public isOpen: boolean = false;
  public parent!: IParentEntity;
  public colorMap: Record<string, string> = suiteColorMap;
  public sortOptions: ISelectItem[] = ResourceService.sortOptions;
  public sortValue: ISelectItem | void = void 0;

  ngOnInit(): void {
    this.parent = this.suite.parentSubject as any;
  }

  onOpen(value: boolean): void {
    this.isOpen = value;
  }

  onSort(value: ISelectItem | void): void {
    if (value && value.id === 'asc') {
      this.suite.series.sort((a, b) => {
        return a.title.localeCompare(b.title);
      });
    } else if (value && value.id === 'desc') {
      this.suite.series.sort((a, b) => {
        return b.title.localeCompare(a.title);
      });
    }
  }

  onPreventClick(e: Event): void {
    if (e && e.preventDefault) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
}

export {
  SuiteComponent,
  suiteColorMap,
};
